import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useId, useState } from 'react';

import { Label } from '~/components/shadcn/label.tsx';
import { Skeleton } from '~/components/shadcn/skeleton.tsx';
import { Switch } from '~/components/shadcn/switch.tsx';
import { useTranslations } from '~/i18n/use-translations.ts';
import { WebPushSettings } from '~/modules/push-notifications/WebPushSettings.tsx';
import { getUserSettingsPageDataQueryOptions } from '~/server/user/user-settings-page-data-query.ts';
import { cn } from '~/utils/cn.ts';
import { ClientOnly } from '~/utils/is-browser.tsx';

export const Route = createFileRoute('/user/notifications')({
	component: UserNotificationsPage,
});

function UserNotificationsPage() {
	const t = useTranslations();
	useSuspenseQuery(getUserSettingsPageDataQueryOptions());
	const switchId = useId();
	const [isNotificationSoundEnabled, setIsNotificationSoundEnabled] = useState(false);

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex flex-col gap-y-8">
				<ClientOnly fallback={<Skeleton />}>{() => <WebPushSettings />}</ClientOnly>

				<div className="flex flex-row justify-between py-2">
					<Label className="pr-2 font-medium text-base" htmlFor={switchId} title={t('userNotifications.soundTitle')}>
						{isNotificationSoundEnabled ? t('userNotifications.disableSound') : t('userNotifications.enableSound')}
					</Label>
					<Switch
						checked={isNotificationSoundEnabled}
						className="data-[state=unchecked]:bg-card"
						id={switchId}
						onCheckedChange={() => setIsNotificationSoundEnabled((prev) => !prev)}
					/>
				</div>

				<div className="flex w-full text-foreground">{t('userNotifications.timeoutTodo')}</div>

				<div className="flex w-full text-foreground">{t('userNotifications.languageTodo')}</div>
			</div>

			<div className="mt-auto mb-4 ml-auto flex">
				<Link
					className={cn(
						'w-full cursor-pointer p-2 transition duration-300 ease-in-out',
						'inline-flex shrink-0 select-none flex-wrap items-center justify-center align-middle',
						'text-muted-foreground',
						'bg-card',
						'border border-border',
						'hover:border-foreground-primary',
					)}
					preload="intent"
					title={t('userNotifications.open')}
					to="/notifications"
				>
					<span>{t('nav.notifications')}</span>
				</Link>
			</div>
		</div>
	);
}
